import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import SessionForm from 'components/organisms/forms/SessionForm'
import { useGET_groupCourseSessionsQuery } from 'redux/api/sessionsApi'
import { Box, Button, Grid } from '@mui/material'
import { FaCalendarAlt, FaChalkboardTeacher } from 'react-icons/fa'
import { useState } from 'react'
import BoxTitle from 'components/atoms/BoxTitle'
import { addMinutes, format } from 'date-fns'
import formModel from 'utils/formModels/sessionFilterModel'
import { Form, Formik } from 'formik'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const TeacherClassroomPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [showForm, setShowForm] = useState(false)

  const [today, setToday] = useState(new Date)

  const { data: sessions } = useGET_groupCourseSessionsQuery({
    page: 1,
    ordering: 'start_datetimie',
    start_date_from: format(today, 'yyyy-MM-dd'),
    start_date_to: format(today, 'yyyy-MM-dd'),
  })

  const list = []

  sessions?.results.forEach((session) => {
    list.push({
      groupId: 'session',
      title: `${session?.group} / ${session?.course}`,
      url: `/sessions/edit/${session.id}`,
      start: format(new Date(session.start_datetime), 'p'),
      end: session.duration_minutes
        ? format(addMinutes(new Date(session.start_datetime), session.duration_minutes), 'p')
        : null,
    })
  })

  const { 
      start_datetime, 
  } = formModel()

  const prevDay = () => {
    today.setDate(today.getDate() - 1)  
    const newToday = new Date(today)
    setToday(newToday)
  }

  const nextDay = () => {
    today.setDate(today.getDate() + 1)
    const newToday = new Date(today)
    setToday(newToday)
  }
  


  return ( <>
      <PageHeading title={`${t('common.schedule-a-lesson')}`} />
        <PageBody>

          {!showForm && <div style={{ textAlign: 'right' }}><Button 
              onClick={() => { 
                  setShowForm(true)
              } }
              aria-label={t('common.schedule-a-lesson')}
              color='green'
              variant='contained'
              sx={{ }}>
                  {t('common.schedule-a-lesson')}
          </Button></div>}

      
          {showForm && <SessionForm action={'add'} id={null} group_course_id={null} viewOnly={false} />}


          <Grid container spacing={2} mt={4}>
            <Grid item xs={12} lg={3}>

              <Formik
                enableReinitialize
                initialValues={{
                  start_datetime: today
                }}
                validationSchema={null}
                onSubmit={(values) => {
                }}
              >{({ values, setFieldValue, errors }) => (
                <Form>

                  {/*
                  <div style={{ fontWeight: 'bold', textAlign: 'center', marginTop: '20px' }}>
                    <span>&bull;</span> Date with schedule lessons
                  </div>
                  */}

                  <div style={{ position: 'relative' }}>
                    <DatePickerField fieldProps={{ ...start_datetime }}  
                      onChange={(value: Date) => {
                        setToday(value)
                      }} />
                  </div>

                </Form>
              )}
              </Formik>

            </Grid>      
            <Grid item xs={12} lg={9}>
              <Box padding={2} style={{
                border: '1px solid #FFB800',
                borderRadius: '20px',
                
               }}>
                  <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>

                    <div style={{ width: '100%' }}>
                      <BoxTitle title={ t('dashboard.my-daily-schedule') } icon={<FaChalkboardTeacher style={{ fontSize: '26px'}} />} />
                    </div>

                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center', marginLeft: 'auto'}}>
                      <div><ChevronLeft color='primary' sx={{fontSize: '40px', cursor: 'pointer'}} onClick={() => prevDay()}/></div>
                      
                      <div style={{ textAlign: 'center', fontSize: '20px' }}>
                          <div style={{ position: 'relative', top: '-5px' }}>{format(today, 'dd/MM/yyy')}</div>
                      </div>

                      <div><ChevronRight color='primary' sx={{fontSize: '40px',cursor: 'pointer'}} onClick={() => nextDay()}/></div>

                    </div>
                  </div>
                    

               
                    {
                      list.map((item, index) => 
                        <div onClick={() => navigate(item.url)} key={index} className='subject-group-line'> 
                          <div className="subject-group-title" style={{ fontWeight: 'normal', fontSize: '14px'}}>{`${item.title}`}</div>
                          <div className="subject-group-icons">
                              <FaCalendarAlt /> {`${item.start} - ${item.end}`}
                          </div>
                          <span style={{ fontSize: '0.8rem', marginRight: '10px' }}></span> 
                        </div>
                    )}


              </Box>
            </Grid>     

          </Grid>    


          
        </PageBody>
      </> 
    
  )
}
export default TeacherClassroomPage

